<nz-anchor>
  <nz-link nzHref="#" nzTitle="Basic demo"></nz-link>
  <nz-link nzHref="#" nzTitle="Static demo"></nz-link>
  <nz-link nzHref="#" nzTitle="API">
    <nz-link nzHref="#" nzTitle="nz-anchor"></nz-link>
    <nz-link nzHref="#" nzTitle="nz-link"></nz-link>
  </nz-link>
</nz-anchor>
